module.exports = __webpack_public_path__ + "static/media/home.fa0ec875.svg";